<template>
    <v-tab-item :value="$route.path" class="pa-3">
        <v-toolbar flat height="90">
            <v-btn
                color="secondary"
                class="text-capitalize px-5"
                depressed
                v-text="translations.add[lang]"
                @click="openVariantDialog('create', {})"
            ></v-btn>
        </v-toolbar>
        <v-row no-gutters justify="end" class="px-4 pb-3 align-end">
            <div class="mr-auto"></div>

            <v-col cols="4" class="pa-0">
                <b-search-field v-model="search"></b-search-field>
            </v-col>
        </v-row>
        <b-data-table
            :headers="headers"
            :items="variants"
            :page.sync="page"
            @page-sync="p => (page = p)"
            :loading="loading"
            disable-sort
            class="b-outlined"
        >
            <template v-slot:item.image_url="{ item }">
                <v-img
                    :src="item.image_url"
                    width="70"
                    v-if="item.image_url"
                ></v-img>
                <div v-else>-</div>
            </template>

            <template v-slot:item.variants_prices="{ item }">
                <span v-if="item.variants_prices.length > 1"
                    >{{ Math.min(...item.variants_prices).toFixed(2) }} -
                    {{ Math.max(...item.variants_prices).toFixed(2) }}</span
                >
                <span v-else>{{ item.variants_prices[0] || "-" }}</span>
            </template>

            <template v-slot:item.actions="{ item }">
                <v-tooltip color="secondary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="yellow darken-3"
                            icon
                            v-on="on"
                            @click="openVariantDialog('update', item)"
                        >
                            <v-icon v-text="icons.mdiPencilOutline"></v-icon>
                        </v-btn>
                    </template>

                    <span
                        class="font-weight-bold"
                        v-text="translations.update[lang]"
                    ></span>
                </v-tooltip>

                <v-tooltip color="secondary" top>
                    <template v-slot:activator="{ on }">
                        <v-btn
                            color="red"
                            icon
                            v-on="on"
                            @click="
                                () => {
                                    variant = item;
                                    deleteDialog = true;
                                }
                            "
                        >
                            <v-icon v-text="icons.mdiClose"></v-icon>
                        </v-btn>
                    </template>

                    <span
                        class="font-weight-bold"
                        v-text="translations.delete[lang]"
                    ></span>
                </v-tooltip>
            </template>
        </b-data-table>

        <v-dialog v-model="variantDialog" max-width="600">
            <b-card
                :title="translations[`${mode}`][this.lang]"
                :loading="loading"
                :error-message="errorMessage"
                @cancel="closeForm"
                @submit="submitForm"
                :submit-text="{ el: 'Αποθήκευση', en: 'Save', it: 'Salva' }"
                :cancel-text="{ el: 'Ακύρωση', en: 'Cancel', it: 'Cancella' }"
            >
                <b-text-field
                    v-model="variant.name[nameLang]"
                    :label="translations.name[lang]"
                    :success="success.name"
                    :error-messages="error.name"
                    @focus="error.name = ''"
                    @blur="validateName"
                >
                    <template v-slot:append>
                        <b-lang-menu
                            v-model="nameLang"
                            type="inner"
                        ></b-lang-menu>
                    </template>
                </b-text-field>

                <b-textarea
                    v-model="variant.description[descriptionLang]"
                    :label="translations.description[lang]"
                    :success="success.description"
                    :error-messages="error.description"
                    @focus="error.description = ''"
                    @blur="validateDescription"
                >
                    <template v-slot:append>
                        <b-lang-menu
                            v-model="descriptionLang"
                            type="inner"
                        ></b-lang-menu>
                    </template>
                </b-textarea>
                <v-row>
                    <v-col cols="12" md="6">
                        <b-text-field v-model="variant.sku_number" label="SKU"
                        :success="success.sku_number"
                        :error-messages="error.sku_number"
                        @focus="error.sku_number = ''"
                        @blur="validateSku"
                        >
                        </b-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <b-text-field
                            v-model="variant.price"
                            :label="translations.price[lang]"
                            prepend-inner-icon="mdiCurrencyEur"
                            type="number"
                            :success="success.price"
                            :error-messages="error.price"
                            @focus="error.price = ''"
                            @blur="validatePrice"
                        >
                        </b-text-field>
                    </v-col>
                </v-row>
                <v-autocomplete
                    :items="spreadOptions"
                    return-object
                    v-model="selectedOptionAttributes"
                    :label="translations.attributeOptions[lang]"
                    multiple
                    small-chips
                    dense
                    class="mt-3"
                    menu-props="offsetY"
                    color="secondary"
                    item-color="secondary"
                    outlined
                    clearable
                    open-on-clear
                    hide-details="auto"
                    :filter="filterAttributes"
                    :success="success.attribute_option_ids"
                    :error-messages="error.attribute_option_ids"
                    @focus="error.attribute_option_ids = ''"
                    @blur="validateAttributes"
                >
                </v-autocomplete>
                <v-row>
                    <v-col cols="12" md="6">
                        <b-text-field
                            v-model="variant.inventory"
                            :label="translations.inventory[lang]"
                            type="number"
                            :success="success.inventory"
                            :error-messages="error.inventory"
                            @focus="error.inventory = ''"
                            @blur="validateInventory"
                        >
                        </b-text-field>
                    </v-col>
                    <v-col cols="12" md="6"> </v-col>
                </v-row>
                <v-checkbox
                    v-model="variant.visible"
                    color="secondary"
                    class="mt-3 pt-0"
                    hide-details="auto"
                >
                    <template v-slot:label>
                        <h4 class="secondary--text">
                            {{ translations.publish[lang] }}
                        </h4>
                    </template>
                </v-checkbox>
            </b-card>
        </v-dialog>

        <v-dialog v-model="deleteDialog" max-width="500">
            <b-card
                type="delete"
                :title="translations.delete[lang]"
                :submit-text="translations.delete"
                :loading="loading"
                :error-message="errorMessage"
                @cancel="deleteDialog = false"
                @submit="deleteItem()"
            >
                <div class="subtitle-1 font-weight-medium pt-2 px-2">
                    {{ translations.deleteConfirmationMessage[lang] }}
                    <span class="font-weight-bold text--primary">{{
                        variant.name[lang]
                    }}</span
                    >{{ translations.questionmark[lang] }}
                </div>
            </b-card>
        </v-dialog>
    </v-tab-item>
</template>

<script>
import { mdiPencilOutline, mdiClose } from "@mdi/js";

import { mapState, mapMutations, mapActions } from "vuex";
import debounce from "lodash/debounce";
import translations from "@/utils/translations/general/settings/roadcubeMarket";
import { cloneDeep } from "lodash";
import validators from "@/utils/validators/general/settings/roadcubeMarket/variant";

export default {
    name: "Variants",

    mixins: [translations, validators],

    data() {
        return {
            icons: { mdiPencilOutline, mdiClose },
            page: +this.$route.query.page,
            mode: "create",
            search: "",
            variantDialog: false,
            deleteDialog: false,
            nameLang: this.$route.params.lang,
            changeNameElAuto: true,
            changeNameItAuto: true,
            changeNameEnAuto: true,
            descriptionLang: this.$route.params.lang,
            changeDescriptionElAuto: true,
            changeDescriptionItAuto: true,
            changeDescriptionEnAuto: true,
            variantLang: this.$route.params.lang,
            selectedOptionAttributes: [],
        };
    },

    computed: {
        ...mapState(["loading", "errorMessage"]),

        ...mapState("general/settings/roadcubeMarket/variants", [
            "variants",
            "variant"
        ]),
        ...mapState("general/settings/roadcubeMarket/attributeOptions", [
            "attributeOptions"
        ]),
        ...mapState("general/settings/roadcubeMarket/attributes", [
            "attributes"
        ]),

        lang() {
            return this.$route.params.lang;
        },

        headers() {
            return [
                {
                    text: this.translations.name[this.lang],
                    value: `name['${this.lang}']`
                },
                {
                    text: this.translations.description[this.lang],
                    value: `description['${this.lang}']`
                },
                {
                    text: this.translations.actions[this.lang],
                    value: "actions"
                }
            ];
        },

        variant: {
            get() {
                return this.$store.state.general.settings.roadcubeMarket
                    .variants.variant;
            },

            set(val) {
                this.setVariant(val);
            }
        },

        query() {
            let query = "?";

            for (let key in this.$route.query) {
                query += `${key}=${this.$route.query[key]}&`;
            }

            return query.slice(0, query.length - 1);
        },
        
        selectedAttributeIds() {
            return this.selectedOptionAttributes.map(opt =>  opt.attribute_id)
        },

        optionGroups() {
            let groups = this.attributeOptions?.reduce((a,c)=>{
                let item = {
                    ...c,
                    text: c.option?.[this.lang] || '',
                    value: c.attribute_option_id,
                    disabled : this.selectedAttributeIds.includes(c.attribute_id) && !this.variant.attribute_option_ids.includes(c.attribute_option_id),
                }
                let group = a?.find(x => x.attribute_id == c.attribute_id) 
                if (!group?.items) {
                    let attribute = this.attributes.find(x => x.attribute_id == c.attribute_id)
                    item.search = `${( attribute&&attribute.name ? attribute.name[this.lang] : '')} ${c.option ? c.option[this.lang]: ''}`
                    group = {
                        attribute_id: c.attribute_id,
                        header: attribute?.name[this.lang] || '',
                        search: item.search,
                        divider: true,
                        items: [item]
                    }
                    a.push(group)
                }else{
                    group.search += ` ${c.option ? c.option[this.lang]: ''}`
                    item.search = `${group.header || ''} ${c.option ? c.option[this.lang]: ''}`
                    group.items.push(item)
                }
                return a
            },[]) || []
            return groups
        },

        spreadOptions(){
            return this.optionGroups.reduce((a,c)=> [...a, c, ...c.items], [])
        },
    },

    methods: {
        ...mapMutations("general/settings/roadcubeMarket/variants", [
            "setVariant"
        ]),
        ...mapActions("general/settings/roadcubeMarket/variants", [
            "getVariants",
            "create",
            "update",
            "delete"
        ]),
        ...mapActions("general/settings/roadcubeMarket/attributeOptions", [
            "getAttributeOptions"
        ]),
        
        ...mapActions("general/settings/roadcubeMarket/attributes", [
            "getAttributes"
        ]),
        openVariantDialog(mode, item) {
            this.mode = mode;
            this.variant = cloneDeep(item);
            this.variantDialog = true;
        },

        handleSearch() {
            if (this.page != 1) {
                this.page = 1;
            } else {
                this.getVariants(`?q=${this.search}`);
            }
        },

        async submitForm() {
            let item = cloneDeep(this.variant);
            item.attribute_option_ids = this.selectedOptionAttributes.map( e => e.attribute_option_id)
            item.visible = item.visible || false;
            for (let key of Object.keys(item)) {
                item[key] = item[key] === null ? undefined : item[key];
            }
            let res = await this[this.mode](item);
            if (res) {
                await this.getVariants();
                this.closeForm();
            }
        },

        async deleteItem() {
            let item = cloneDeep(this.variant);
            let res = await this.delete(item.variant_id);
            if (res) {
                await this.getVariants();
                this.closeForm();
            }
        },
        closeForm() {
            this.changeNameElAuto = true;
            this.changeNameItAuto = true;
            this.changeNameEnAuto = true;
            this.changeDescriptionElAuto = true;
            this.changeDescriptionItAuto = true;
            this.changeDescriptionEnAuto = true;
            this.search = "";
            this.variantDialog = false;
            this.deleteDialog = false;
        },

        filterAttributes(item, queryText){
            if (!queryText) {
                return true
            }
            return item.search?.toLowerCase().includes(queryText.toLowerCase())
        }
    },

    watch: {
        $route(val) {
            if (!val.query.page) {
                this.$router.replace({
                    query: {
                        page: 1,
                        ...this.$route.query
                    }
                });
            }
            this.getVariants(`${this.query}&q=${this.search}`);
        },

        page(page) {
            this.$router.replace({ query: { ...this.$route.query, page } });
        },

        search(val) {
            if (val == null) {
                this.getVariants(this.query);
            } else {
                this.debouncedSearch();
            }
        },
        
        selectedOptionAttributes: {
            handler(val){
                this.variant.attribute_option_ids = val.map( e => e.attribute_option_id)
            },
            deep: true
        },
        
        ["variant.attributes"]: {
            handler(val){
                if (val) {
                    this.selectedOptionAttributes = []
                    val.forEach(opt => {
                        let spreadOption = this.spreadOptions.find(x => x.attribute_option_id == opt.attribute_option.attribute_option_id)
                        this.selectedOptionAttributes.push(spreadOption)
                    })
                }
            },
            deep: true
        },

        ["$route.params.lang"](val) {
            this.nameLang = val;
            this.descriptionLang = val;
        },

        ["variant.name.en"](val) {
            if (this.lang == "en") {
                if (this.changeNameElAuto) {
                    this.variant.name.el = val;
                }

                if (this.changeNameItAuto) {
                    this.variant.name.it = val;
                }

                this.changeNameEnAuto = false;
            } else if (val != this.variant.name[this.lang]) {
                this.changeNameEnAuto = false;
            }
        },

        ["variant.name.el"](val) {
            if (this.lang == "el") {
                if (this.changeNameEnAuto) {
                    this.variant.name.en = val;
                }

                if (this.changeNameItAuto) {
                    this.variant.name.it = val;
                }

                this.changeNameElAuto = false;
            } else if (val != this.variant.name[this.lang]) {
                this.changeNameElAuto = false;
            }
        },

        ["variant.name.it"](val) {
            if (this.lang == "it") {
                if (this.changeNameElAuto) {
                    this.variant.name.el = val;
                }

                if (this.changeNameEnAuto) {
                    this.variant.name.en = val;
                }

                this.changeNameItAuto = false;
            } else if (val != this.variant.name[this.lang]) {
                this.changeNameItAuto = false;
            }
        },

        ["variant.description.en"](val) {
            if (this.lang == "en") {
                if (this.changeDescriptionElAuto) {
                    this.variant.description.el = val;
                }

                if (this.changeDescriptionItAuto) {
                    this.variant.description.it = val;
                }

                this.changeDescriptionEnAuto = false;
            } else if (val != this.variant.description[this.lang]) {
                this.changeDescriptionEnAuto = false;
            }
        },

        ["variant.description.el"](val) {
            if (this.lang == "el") {
                if (this.changeDescriptionEnAuto) {
                    this.variant.description.en = val;
                }

                if (this.changeDescriptionItAuto) {
                    this.variant.description.it = val;
                }

                this.changeDescriptionElAuto = false;
            } else if (val != this.variant.description[this.lang]) {
                this.changeDescriptionElAuto = false;
            }
        },

        ["variant.description.it"](val) {
            if (this.lang == "it") {
                if (this.changeDescriptionElAuto) {
                    this.variant.description.el = val;
                }

                if (this.changeDescriptionEnAuto) {
                    this.variant.description.en = val;
                }

                this.changeDescriptionItAuto = false;
            } else if (val != this.variant.description[this.lang]) {
                this.changeDescriptionItAuto = false;
            }
        }
    },

    beforeCreate() {
        if (!this.$route.query.page) {
            this.$router.replace({
                query: {
                    page: 1,
                    ...this.$route.query
                }
            });
        }
    },

    created() {
        this.debouncedSearch = debounce(this.handleSearch, 500);
    },

    mounted() {
        this.getVariants(this.query);
        this.getAttributeOptions();
        this.getAttributes();
    }
};
</script>
<style>
.csv-input * {
    cursor: pointer;
}
</style>
